import config from '../config/applicationConfiguration';

export const getGoogleCaptchaKey = () => {
    return config.environment.startsWith('LOCAL')
        ? '6LfUnqQUAAAAAIU10Yo9lVr_uvYX9bjz3ifxFo3J' : 'RECAPTCHA_SITE_KEY';
};

export const getFrontendUrl = () => {
    return config.environment.startsWith('LOCAL')
        ? 'localhost' : 'APP_BASE_URL';
};

export const getPublicUrl = () => {
    const appBaseUrl = getFrontendUrl();
    const publicUrl = window.location.hostname.replace(`.${appBaseUrl}`, '').replace(appBaseUrl, '');

    return publicUrl ? publicUrl : null;
};

export const getBaseApiUrl = () => {
    return config.environment.startsWith('LOCAL')
        ? 'http://localhost:3001/api' : '/api';
};


// WEBPACK FOOTER //
// ./src/common/AppContextTools.js